export const PRODUCT_VARIANTS_HITS_PER_PAGE = 80; // Only a small number of products have more than 80 variations, if that's the case, pagination takes care of it
export const PRODUCT_VARIANTS_MAX_REQUEST_AMOUNT = 5; // Hard limit on the pagination requests to avoid any posible infinite cycle
export const MAX_HITS_PER_PAGE = 100;
